import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DashboardSettingsForm.html?raw';
import "../../../moreCore/UI/Button/Button";
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';

import { DashboardTypes } from "./../DashboardTypes";
import { ToasterHelpers } from "../../../more/Helpers";


interface DashboardSettingsData {
    dashboardID: string;
    description: string;
    isDefault: boolean;
    color: string;
    name: string;
}
class DashboardSettingsForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private btnRemoveBackgroundColor: HTMLButtonElement;

    private dashboardData: DashboardTypes.Dashboard;
    private inputColor: HTMLInputElement;
    private inputDashboardTitle: MdsLax<InstanceType<typeof Edit>>;
    private cbIsDefault: MdsLax<InstanceType<typeof CheckBox>>;
    private inputDashboardDescription: MdsLax<InstanceType<typeof Edit>>;

    private _isDirty: boolean = false;
    private emptyColor: boolean = true;

    

    saveDashboard() {
        //this.dashboard.coloration.BackColor.Hex = this.colorInput.value;

        this.dashboardData.name = this.inputDashboardTitle.getValue();
        this.dashboardData.description = this.inputDashboardDescription.getValue();
        this.dashboardData.is_default = this.cbIsDefault.getValue();
        this.dashboardData.color = this.emptyColor ? null : this.inputColor.value;
        this.dashboardData.coloration.BackColor.IsNull = this.emptyColor;
        this.dashboardData.coloration.BackColor.Hex = this.dashboardData.color;

        this._saveSettings();
    }

    private _saveSettings() {
        this.emit("saving", this.dashboardData);

        this.StandbyStart();

        let data: DashboardSettingsData = {
            color: this.dashboardData.color,
            dashboardID: this.dashboardData.ID,
            description: this.dashboardData.description,
            isDefault: this.dashboardData.is_default,
            name: this.dashboardData.name
        }


        this.RequestManager.callfunction(
            "Webtool_API_Dashboard__SaveDashboardSettings",
            data,
            lang.hitch(this, this._onSaveDashboarEntityResponse),
            lang.hitch(this, this._onSaveDashboardEntityError),
            false
        );
    }

    private _onSaveDashboarEntityResponse(response) {
        this.StandbyStop();
        this.setDirty(false);
        this.emit("saved");

        this.showToast(this.translate("General_SavingSuccessful"), ToasterHelpers.ToasterIcons.confirmCheck);
    }

    private _onSaveDashboardEntityError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.emit("dirty", this._isDirty);

        this.showToast({
            title: "error",
            message: error.Message,
            iconClass: ToasterHelpers.ToasterIcons.error,
            showClose: true,
            timeout: -1
        });
    }

    setDirty(isDirty: boolean) {
        this._isDirty = isDirty;
        this.emit("dirty", isDirty);
    }

    isDirty(): boolean {
        return this._isDirty;
    }

    _setValues(dashboard: DashboardTypes.Dashboard) {
        this.dashboardData = dashboard;

        let hex = null;
        if (this.dashboardData.coloration?.BackColor?.Hex && this.dashboardData.coloration?.BackColor?.IsNull == false) {
            this.emptyColor = false;
            hex = this.dashboardData.coloration.BackColor.Hex;
        }
        this.inputColor.value = hex;

        this.hideNode(this.btnRemoveBackgroundColor, this.emptyColor);
        this.UiModder.domClass.toggle(this.inputColor, "w3-opacity", this.emptyColor);

        this.inputDashboardDescription.setValue(this.dashboardData.description, true);
        this.inputDashboardTitle.setValue(this.dashboardData.name, true);

        this.cbIsDefault.setValue(this.dashboardData.is_default, true);
        this.cbIsDefault.setReadonly(true);

        this.setDirty(false);
    }

    private _onChange_Color(evt) {
        this.emptyColor = false;
        this.UiModder.domClass.remove(this.inputColor, "w3-opacity");
        this.hideNode(this.btnRemoveBackgroundColor, false);

        this._onChange_DashboardData();
    }

    private _onChange_DashboardData() {

        this.setDirty(true);
    }

    private _onClick_RemoveBackgroundColor(evt: MouseEvent) {
        this.inputColor.value = null;
        this.emptyColor = true;
        this.UiModder.domClass.add(this.inputColor, "w3-opacity");
        this.hideNode(this.btnRemoveBackgroundColor);


        this.dashboardData.color = null;
        this._onChange_DashboardData();
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DashboardSettingsForm);
